var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.$t("modify"),
            visible: _vm.dialogShow,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  key: "is_prod",
                  staticClass: "lodingItem",
                  attrs: { prop: "is_prod", label: "" }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      on: { change: _vm.Renewal },
                      model: {
                        value: _vm.paramsData.is_prod,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_prod", $$v)
                        },
                        expression: "paramsData.is_prod"
                      }
                    },
                    _vm._l(_vm.severlist, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  key: "server_list",
                  staticClass: "lodingItem",
                  attrs: { prop: "server_list", label: _vm.$t("server") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelectServer")
                      },
                      model: {
                        value: _vm.paramsData.server_list,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "server_list", $$v)
                        },
                        expression: "paramsData.server_list"
                      }
                    },
                    _vm._l(_vm.serverLists, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.serverName, value: item.serverID }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  key: "channel_list",
                  staticClass: "lodingItem",
                  attrs: { prop: "channel_list", label: _vm.$t("channel") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelectChannel")
                      },
                      model: {
                        value: _vm.paramsData.channel_list,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "channel_list", $$v)
                        },
                        expression: "paramsData.channel_list"
                      }
                    },
                    _vm._l(_vm.channelList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.channel_name,
                          value: item.channel_mark
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "turnon", label: _vm.$t("voucherMarketplace") }
                },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-text": _vm.$t("open"),
                      "inactive-text": _vm.$t("close"),
                      "active-color": "#13ce66"
                    },
                    model: {
                      value: _vm.paramsData.turnon,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "turnon", $$v)
                      },
                      expression: "paramsData.turnon"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "", disabled: _vm.issubmit },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }